import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DatePipe, DecimalPipe, NgIf } from '@angular/common';
import { EmptyStateComponent } from '../../../shared/components/empty-state/empty-state.component';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { CustomerService } from '../../services/customer.service';
import { take, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer, CustomerStatementRow } from '../../models/customer.model';
import { getHtmlForCustomerStatement } from '../../utils/customer-statement.print';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

@Component({
    selector: 'app-customer-statement',
    imports: [
        ButtonModule,
        CalendarModule,
        DatePipe,
        EmptyStateComponent,
        NgIf,
        PaginatorModule,
        SharedModule,
        TableModule,
        DecimalPipe,
        FormsModule,
        DatePicker,
    ],
    templateUrl: './customer-statement.component.html',
    styleUrl: './customer-statement.component.scss',
})
export class CustomerStatementComponent implements OnInit {
    dates: Date[] = [];

    customer: Customer;

    offset = 0;

    limit = 10;

    total = 0;

    statementRows: (CustomerStatementRow & { isRoutable: boolean })[] = [];

    routedSources: string[] = ['CUSTOMER_PAYMENT'];

    loading = false;

    tableMinHeight = '0px';

    constructor(
        private readonly customerService: CustomerService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
    ) {}

    ngOnInit() {
        const id = this.route.snapshot.params['id'];
        this.setDefaultDates();
        this.customerService
            .getCustomerById(id)
            .pipe(
                take(1),
                tap((s) => {
                    this.customer = s;
                }),
            )
            .subscribe();
        this.loadStatementPage();
    }

    loadStatementPage() {
        const id = this.route.snapshot.params['id'];
        const [start, end] = this.dates;
        this.customerService
            .getCustomerStatementPage(id, start, end, this.limit, this.offset)
            .pipe(
                take(1),
                tap((res) => {
                    this.total = res.total;
                    this.statementRows = res.result.map((r) => ({
                        ...r,
                        isRoutable: this.routedSources.includes(r.source),
                    }));
                }),
            )
            .subscribe();
    }

    setDefaultDates() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();

        const firstDay = new Date(year, month, 1);
        firstDay.setDate(firstDay.getDate());
        firstDay.setHours(0, 0, 0, 0);

        const lastDay = new Date(year, month + 1, 0);
        lastDay.setDate(lastDay.getDate());
        lastDay.setHours(23, 59, 59, 999);
        this.dates = [firstDay, lastDay];
    }

    onDateChange() {
        if (this.dates.length == 2) {
            this.loadStatementPage();
        }
    }

    printCustomerStatement() {
        const id = this.route.snapshot.params['id'];
        const [start, end] = this.dates;
        this.customerService
            .getCustomerStatementPage(id, start, end)
            .pipe(
                take(1),
                tap((res) => {
                    const WindowPrt = window.open(
                        '',
                        '',
                        'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0',
                    ) as Window;
                    WindowPrt.document.write(getHtmlForCustomerStatement(res.result, this.customer, start, end));
                    WindowPrt.document.close();
                }),
            )
            .subscribe();
    }

    routeToSource(item: CustomerStatementRow) {
        if (item.source === 'CUSTOMER_PAYMENT') {
            this.router.navigate(['customer-payments', item.sourceId]).then();
            return;
        }
        console.error(`not found source in supplier statement ${item.source}`);
    }

    onPageChange($event: PaginatorState) {
        this.offset = $event.first || 0;
        this.limit = $event.rows || 10;
        this.loadStatementPage();
    }

    protected readonly Math = Math;
}
